import React, { useCallback, useMemo } from 'react';
import Button from '@Components/Button/Button';
import LoadingButton from '@Components/LoadingButton/LoadingButton';
import { SettingsTableViewState } from './SettingsTable';

interface ISettingsTableButtonProps
    extends React.HTMLAttributes<HTMLButtonElement> {
    tableState: SettingsTableViewState;
    canEdit: boolean;
    createText: string;
    editText: string;
    submitCreateText?: string;
    submitEditText?: string;
    setCreateState?: () => void;
    setEditState: () => void;
    onCreateNewEntity?: () => void;
    onEditEntity?: () => void;
    canCreateNewEntity?: boolean;
    canEditEntity?: boolean;
    isSubmitting?: boolean;
    hideEditButton?: boolean;
}

const SettingsTableButton = (props: ISettingsTableButtonProps) => {
    if (props.tableState === SettingsTableViewState.VIEW) {
        return (
            <Button
                id={props.id}
                color="blue"
                onClick={
                    props.canEdit ? props.setEditState : props.setCreateState
                }
            >
                {props.canEdit ? props.editText : props.createText}
            </Button>
        );
    } else if (props.tableState === SettingsTableViewState.CREATE) {
        return (
            <LoadingButton
                id={props.id}
                color="success"
                onClick={props.onCreateNewEntity}
                loading={props.isSubmitting}
                disabled={!props.canCreateNewEntity}
            >
                {props.submitCreateText
                    ? props.submitCreateText
                    : props.createText}
            </LoadingButton>
        );
    } else if (!props.hideEditButton) {
        return (
            <LoadingButton
                id={props.id}
                color="success"
                onClick={props.onEditEntity}
                loading={props.isSubmitting}
                disabled={!props.canEditEntity}
            >
                {props.submitEditText ? props.submitEditText : props.editText}
            </LoadingButton>
        );
    }

    return null;
};

export default SettingsTableButton;
